//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: {
      type: Number,
      default: null,
    },
  },
  methods: {
    select(value) {
      this.$emit('input', value);
    },
    tacoRatingStyle(r) {
      return {
        width: `${(r * 19)}%`,
      };
    },
  },
};
